export default __webpack_public_path__ + "static/media/factory__6.a50e3075.jpg";